export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'Estaba en shock total y no podía parar de mandarle mensajes. El manual me frenó justo a tiempo. Usé la Regla de Oro del Día 1 y por primera vez sentí que yo conducía la situación, no él. Me salvó la dignidad.',
    name: 'Lucía F.',
    location: 'Buenos Aires · Argentina',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/c4912877-2552-46bd-bc1e-c948f180c336.jpg',
  },
  {
    quote:
      'Lo descubrí un viernes a la noche y no sabía qué hacer. El protocolo de las primeras 24 horas me evitó cometer tres errores que hubieran sido irreversibles. Lo recomiendo a cualquiera que esté en ese momento.',
    name: 'Rodrigo M.',
    location: 'Canelones · Uruguay',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/7a285255-6047-46c5-9f19-5dd5198a84c0.jpg',
  },
  {
    quote:
      'El guion de confrontación del Día 5 fue exactamente lo que necesitaba. Hablé sin llorar, sin rogar y con claridad. Nunca pensé que iba a poder tener esa conversación con tanta calma.',
    name: 'Valentina S.',
    location: 'Mendoza · Argentina',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/6384f0cf-90db-4c28-b54d-f9f130ce8625.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'Lo descubrí un martes y para el viernes ya tenía un plan. Sin el manual hubiera cometido el error de confrontar sin estrategia y perder toda la evidencia. Vale cada peso.',
    name: 'Sebastián R.',
    location: 'Córdoba · Argentina',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/ed649827-3bd1-4800-b3e3-bd9d2f224c24.jpg',
  },
  {
    quote:
      'El tomo del Gaslighting me abrió los ojos. Me estaban haciendo dudar de lo que yo misma había visto. El manual me devolvió la confianza en mis propios sentidos.',
    name: 'Mariana C.',
    location: 'Bogotá · Colombia',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/076e4df0-fb0e-4b7d-86ea-40eedfbcd488.jpg',
  },
  {
    quote:
      "Venía de una semana sin dormir y sin poder comer. El bono de 'Apagá el Infierno Mental' fue lo primero que leí y esa noche dormí por primera vez en días.",
    name: 'Diego F.',
    location: 'Asunción · Paraguay',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/7bb77e3a-c5b3-4ddc-9a9c-90e780dcf207.jpg',
  },
  {
    quote:
      'No sabía si quedarme o irme. El Mapa de Decisión del Día 6 me dio la claridad que meses de vueltas en mi cabeza no me habían dado. Tomé la decisión más importante de mi vida con la cabeza fría.',
    name: 'Carolina B.',
    location: 'Buenos Aires · Argentina',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/ba16684a-8b21-4ed6-8a96-844b46cf6770.jpg',
  },
];
